<template>
  <div>
    <!-- <v-toolbar flat dense>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn text color="primary">
          <v-icon left>add</v-icon> เพิ่มรูปภาพ
        </v-btn>
      </v-toolbar-items>
    </v-toolbar> -->
    <v-row>
      <v-col cols="6" class="pb-0">
        <p class="title">
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertExam.insertGame.randomType'
            )
          }}
          <span class="red--text">*</span>
        </p>
        <v-radio-group v-model="setRandomChoice" mandatory row hide-details>
          <v-radio
            :label="
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.insertExam.insertGame.noRandom'
              )
            "
            :value="false"
          ></v-radio>
          <v-radio
            :label="
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.insertExam.insertGame.random'
              )
            "
            :value="true"
            :disabled="imgPair.length < 3"
          ></v-radio>
        </v-radio-group>
      </v-col>
      <v-col cols="3" class="pb-0">
        <p class="title">
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertExam.insertGame.countRandom'
            )
          }}
        </p>
        <v-text-field
          :disabled="imgPair.length < 3 || setRandomChoice == false"
          type="number"
          outlined
          clearable
          class="textField"
          :placeholder="
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertExam.insertGame.countRandom'
            )
          "
          v-model.number="randomItems"
          min="0"
          :rules="randomRules"
          @change="checkMaxRandom"
        ></v-text-field>
      </v-col>
      <v-col cols="3" class="pb-0">
        <p class="title">
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertExam.insertGame.score'
            )
          }}
          <span class="red--text">*</span>
        </p>
        <v-text-field
          type="number"
          outlined
          :rules="scoreRules"
          clearable
          class="textField"
          :placeholder="
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertExam.insertGame.score'
            )
          "
          v-model.number="question_score"
          min="0"
          @change="checkMinScore"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <p class="subtitle-1 mb-0">
          <span>
            <v-icon left color="blue">mdi-information-outline</v-icon> </span
          >{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertExam.insertGame.msg4'
            )
          }}
        </p>
      </v-col>
    </v-row>

    <template v-for="(item, idx) of imgPair">
      <v-card :key="`card_${idx}`" outlined class="mb-4">
        <div class="subtitle-1 px-4 pt-4">
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertExam.insertGame.packGame'
            )
          }}
          {{ idx + 1 }}
        </div>
        <div class="d-flex pa-4 align-center">
          <div class="flex-grow-1">
            <div class="d-flex">
              <div class="pr-2 flex-shrink-1">
                <v-card flat tile class="">
                  <image-picker
                    :accept="'image/*'"
                    :as-data-url="true"
                    @onFileChoose="onFileChoose($event, idx, 0)"
                    @onFileEmpty="onFileEmpty($event, idx, 0)"
                  >
                    <div :style="{ width: '200px', height: '200px' }">
                      <template v-if="item.imgs[0].dataUrl != null">
                        <v-img
                          :src="item.imgs[0].dataUrl"
                          aspect-ratio="1"
                          class="grey lighten-2"
                          :max-height="200"
                          :max-width="200"
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="grey lighten-5"
                              ></v-progress-circular>
                            </v-row>
                          </template>

                          <v-row
                            no-gutters
                            align="end"
                            class="lightbox white--text fill-height"
                          >
                            <v-col>
                              <div class="text-right">
                                <v-btn
                                  dark
                                  icon
                                  @click.stop="removePic(idx, 0)"
                                >
                                  <v-icon small>mdi-close</v-icon>
                                </v-btn>
                              </div>
                            </v-col>
                          </v-row>
                        </v-img>
                      </template>
                      <template v-else>
                        <div
                          class="d-flex align-center justify-center fill-height"
                        >
                          <v-icon size="64">mdi-image</v-icon>
                        </div>
                      </template>
                    </div>
                    <!-- <template v-slot:default="{ item }">
                      
                    </template> -->
                  </image-picker>
                </v-card>
              </div>
              <div class="flex-shrink-1 pl-2">
                <v-card flat tile class="">
                  <image-picker
                    :accept="'image/*'"
                    :as-data-url="true"
                    @onFileChoose="onFileChoose($event, idx, 1)"
                    @onFileEmpty="onFileEmpty($event, idx, 1)"
                  >
                    <div :style="{ width: '200px', height: '200px' }">
                      <template v-if="item.imgs[1].dataUrl != null">
                        <v-img
                          :src="item.imgs[1].dataUrl"
                          aspect-ratio="1"
                          class="grey lighten-2"
                          :max-height="200"
                          :max-width="200"
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="grey lighten-5"
                              ></v-progress-circular>
                            </v-row>
                          </template>

                          <v-row
                            v-if="!item.single"
                            no-gutters
                            align="end"
                            class="lightbox white--text fill-height"
                          >
                            <v-col>
                              <div class="text-right">
                                <v-btn
                                  dark
                                  icon
                                  @click.stop="removePic(idx, 1)"
                                >
                                  <v-icon small>mdi-close</v-icon>
                                </v-btn>
                              </div>
                            </v-col>
                          </v-row>
                        </v-img>
                      </template>
                      <template v-else>
                        <div
                          class="d-flex align-center justify-center fill-height"
                        >
                          <v-icon size="64">mdi-image</v-icon>
                        </div>
                      </template>
                    </div>
                    <!-- <template v-slot:default="{ item }">
                      
                    </template> -->
                  </image-picker>
                </v-card>
                <div class="mt-0 pt-2">
                  <v-checkbox
                    class="mt-0 pt-0"
                    v-model="item.single"
                    :label="
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.insertGame.msg1'
                      )
                    "
                    hide-details
                    :disabled="item.imgs[0].dataUrl == null"
                    @change="onUseSinglePic($event, idx)"
                  ></v-checkbox>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="flex-shrink-1 ml-4" style="max-width: 150px">
            <p class="caption mb-2">
              คะแนน
              <span class="red--text">*</span>
            </p>
            <v-text-field
              type="number"
              outlined
              :rules="scoreRules"
              clearable
              class="textField"
              placeholder="คะแนน"
              v-model.number="item.score"
              min="0"
            ></v-text-field>
          </div> -->
          <v-divider vertical class="my-4 mx-4"></v-divider>
          <div class="flex-shrink-1">
            <v-btn
              elevation="0"
              class="mb-0 body-2 error--text text-capitalize"
              color="white"
              @click="removePairImg(idx)"
              :disabled="imgPair.length == 1"
            >
              <p class="mb-0">
                {{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertExam.delete'
                  )
                }}
              </p>
            </v-btn>
          </div>
        </div>
      </v-card>
    </template>

    <v-row>
      <v-col cols="12" class="text-right mt-0 pt-0">
        <v-btn
          elevation="0"
          class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light button-primary"
          @click="addRowAnswer"
          >{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertExam.insertGame.addPhoto'
            )
          }}</v-btn
        >
      </v-col>
    </v-row>

    <input
      type="file"
      multiple
      ref="fileSelector"
      accept="image/*"
      @change="fileChange"
      style="width: 0px; height: 0px; position: absolute"
    />
  </div>
</template>

<script>
import ImagePicker from '@/components/file-selector.vue';
export default {
  components: { ImagePicker },
  props: ['options', 'answerLength', 'gameBody'],
  data: () => ({
    randomItems: 1,
    imgPair: [],
    answer_description: '',
    editState: false,
    gameReady: false,
    setRandomChoice: false,
    question_score: 1,
    scoreRules: [
      (v) =>
        !!v ||
        this.$vuetify.lang.t(
          '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.scoreRules'
        ),
    ],
    randomRules: [
      (v) =>
        v > 0 ||
        this.$vuetify.lang.t(
          '$vuetify.courseManagement.lectureStep.insertExam.insertGame.randomRules'
        ),
    ],
    mode: 'add',
  }),
  watch: {
    gameReady(val) {
      this.$emit('onGameReady', val);
    },
    setRandomChoice(val) {
      if (val === true) {
        this.randomItems = this.imgPair.length - 1;
      } else {
        // this.randomItems = 0;
      }
      this.checkReady();
    },
    randomItems(val, oldVal) {
      if (this.setRandomChoice === true) {
        if (val == null) {
          this.gameReady = false;
        }
      }
    },
    imgPair: {
      deep: true,
      handler: function (val) {
        if (val.length > 1) {
          this.randomItems = this.imgPair.length - 1;
        } else {
          this.setRandomChoice = false;
          this.randomItems = 1;
        }

        this.$emit('update:answerLength', val.length);

        // check game ready
        this.checkReady();
      },
    },
  },
  mounted() {
    this.startup();
  },
  methods: {
    startup(isEdit = false) {
      // console.log("start", this.mode);
      if (isEdit === true) {
        // set data to renderer
        this.mode = 'edit';
        this.init();
      } else {
        this.mode = 'add';
        this.imgPair = [];
        this.addRowAnswer();
      }
    },
    init() {
      // console.log("component", this.gameBody);
      if (this.gameBody != null) {
        this.imgPair = this.gameBody.config;
        this.randomItems = this.gameBody.randomLimit;
        this.setRandomChoice = this.gameBody.isRandom;
        this.question_score = this.gameBody.score || 1;
        this.checkReady();
      }
    },
    checkReady() {
      let dataOk = true;
      for (let pair of this.imgPair) {
        let imgValid = true;
        for (let img of pair.imgs) {
          if (img.dataUrl == null || img.dataUrl == '') {
            imgValid = false;
            break;
          }
        }

        // if (imgValid) {
        //   if (pair.score == null) {
        //     dataOk = false;
        //     break;
        //   }
        // } else {
        //   dataOk = false;
        //   break;
        // }
      }

      // check randomize items
      if (this.setRandomChoice === true) {
        if (this.randomItems == null) {
          dataOk = false;
        }
      }

      // console.log(dataOk)

      this.gameReady = dataOk;
    },
    onUseSinglePic(e, idx) {
      if (e === true) {
        // this.imgPair[idx].imgs[1].file = this.imgPair[idx].imgs[0].file;
        this.imgPair[idx].imgs[1].file = null;
        this.imgPair[idx].imgs[1].dataUrl = this.imgPair[idx].imgs[0].dataUrl;
      } else {
        this.imgPair[idx].imgs[1].file = null;
        this.imgPair[idx].imgs[1].dataUrl = null;
      }
    },
    onFileChoose(e, idx, imgIdx) {
      this.imgPair[idx].imgs[imgIdx].file = e.file;
      this.imgPair[idx].imgs[imgIdx].dataUrl = e.dataUrl;
      if (imgIdx == 0) {
        if (this.imgPair[idx].single === true) {
          this.onUseSinglePic(true, idx);
        }
      }
    },
    onFileEmpty(e, idx, imgIdx) {
      this.removePic(idx, imgIdx);
    },
    checkMaxRandom() {
      // check null
      if (this.randomItems == null) {
        this.randomItems = this.imgPair.length - 1;
      }

      // check over size
      if (this.randomItems >= this.imgPair.length) {
        this.randomItems = this.imgPair.length - 1;
      }
    },
    edit() {
      this.editState = true;
    },
    removePic(idx, imgIdx) {
      this.imgPair[idx].imgs[imgIdx].file = null;
      this.imgPair[idx].imgs[imgIdx].dataUrl = null;
      this.imgPair[idx].imgs[imgIdx].url = null;
    },
    addRowAnswer() {
      // console.log("add new row", this.imgPair);
      let pair = {
        imgs: [],
        single: false,
        // score: 1,
      };
      pair.imgs.push({
        file: null,
        dataUrl: null,
      });
      pair.imgs.push({
        file: null,
        dataUrl: null,
      });
      this.imgPair.push(pair);
    },
    removePairImg(index) {
      this.imgPair.splice(index, 1);

      if (this.imgPair.length < 3) {
        this.setRandomChoice = false;
      }
    },
    fileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (files.length == 0) {
        this.file = null;
        this.preview = null;
      } else if (files.length == 2) {
        // console.log(files[0].size);
        let limitSizePass = true;
        for (let file of files) {
          if (file.size >= 4000000) {
            limitSizePass = false;
            break;
          }
        }

        if (limitSizePass) {
          this.imgPair.push({
            // score: 1,
            first: files[0],
            second: files[1],
            firstSrc: null,
            secondSrc: null,
            firstId: null,
            secondId: null,
          });
        } else {
          alert('ขาดไฟล์รูปใดรูปหนึ่งมีขนาดเกิน 4MB');
        }
      } else {
        alert('กรุณาเลือกไฟล์รูปภาพ จำนวน 2 รูป');
      }
    },
    genPreview() {
      for (let i in this.imgPair) {
        //#region read first pic
        let reader1 = new FileReader();

        reader1.onload = (e) => {
          // get loaded data and render thumbnail.
          this.imgPair[i].firstSrc = e.target.result;
        };

        // read the image file as a data URL.
        reader1.readAsDataURL(this.imgPair[i].first);
        //#endregion

        //#region read second pic
        let reader2 = new FileReader();

        reader2.onload = (e) => {
          // get loaded data and render thumbnail.
          this.imgPair[i].secondSrc = e.target.result;
        };

        // read the image file as a data URL.
        reader2.readAsDataURL(this.imgPair[i].second);
        //#endregion
      }
    },
    getGameBody() {
      return {
        config: this.imgPair,
        isRandom: this.setRandomChoice,
        randomLimit: this.randomItems,
        score: this.question_score,
      };
    },
    checkMinScore() {
      if (this.question_score < 0) this.question_score = 0;
    },
  },
};
</script>

<style scoped>
.lightbox {
  box-shadow: 0 0 20px inset rgba(0, 0, 0, 0.2);
  background-image: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.4) 0%,
    transparent 72px
  );
}
.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}
.upload-btn-wrapper input[type='file'] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}
.upload-btn-wrapper input[type='file']:hover {
  cursor: pointer;
}
.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 170px !important;
}
.btn-choose {
  color: rgba(0, 0, 0, 0.65);
  background-color: white;
  padding: 8px 20px;
  font-size: 16px;
  width: 170px !important;
  border-radius: 5px;
  border: 1px solid #e0e0e0;
}
</style>